export const emailValidation = /.+@.+\..+/;
export const mobileNumberValidation = /(^(\+88|0088)?(01){1}[3456789]{1}(\d){8})$/;
export const nidValidation = /^[0-9]{10}$|^[0-9]{13}$|^[0-9]{17}$/;
export const numberValidation = /^\+?(|[1-9]\d*)$/;
export const passwordValidation = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
